// How long a metered usage query stays cached after its last subscriber unmounts — the same 5 minutes the Copilot
// dashboard uses. Together with the "MeteredUsage" tag this lets revisits and the person page reuse data instantly;
// the page's Refresh button (and its timed auto-refresh) invalidates the tag to force everything to refetch.
export { COPILOT_CACHE_SECONDS as METERED_USAGE_CACHE_SECONDS } from "state/rtkQuery/copilot/copilotCache";
